import type ErrorData from 'sharedreact/data/ErrorData';
import type Settings from 'sharedreact/data/Settings';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

type OnFetchSuccess = (values?: object) => void;
type OnFetchError = (error: ErrorData) => void;
type OnSaveSuccess = (item: Settings) => void;
type OnSaveError = (item: Settings, error: ErrorData) => void;

function fetch (onSuccess: OnFetchSuccess, onError: OnFetchError): void {
  ConnectionSupport.post(
    'services/getUserPreferences',
    { key: 'MyPreferences' },
    (data) => onSuccess(data.values),
    onError,
    false
  );
}

function save (item: Settings, onSuccess: OnSaveSuccess, onError: OnSaveError): void {
  ConnectionSupport.post(
    'services/saveUserPreferences',
    { key: 'MyPreferences', values: item.toJS() },
    (data) => onSuccess(item),
    (error) => onError(item, error),
    false
  );
}

export default {
  fetch,
  save
};
